import { useRef } from 'react';

import { ButtonVariant } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { StyledEmergencyNotificationButton } from './EmergencyNotificationButton.styled';
import { EmergencyNotificationVariant, useEmergencyNotification } from './useEmergencyNotification';
import { EmergencyNotificationTooltip } from './EmergencyNotificationTooltip';
import { getEmergencyNotificationButtonConfig } from './EmergencyNotificationButton.utils';
import { EmergencyNotificationKeyboardListener } from './EmergencyNotificationKeyboardListener';

type EmergencyNotificationButtonProps = {
   readonly variant: EmergencyNotificationVariant;
};

export const EmergencyNotificationButton = (props: EmergencyNotificationButtonProps): JSX.Element => {
   const buttonRef = useRef<HTMLButtonElement>(null);
   const { state } = useEmergencyNotification();
   const { icon, label } = getEmergencyNotificationButtonConfig(state, props.variant);
   const active = state.type !== 'idle';

   return (
      <>
         <EmergencyNotificationTooltip variant={props.variant}>
            <StyledEmergencyNotificationButton
               testId={'emergencyNotification'}
               $active={active}
               label={
                  <>
                     {icon}
                     <Translate>{label}</Translate>
                  </>
               }
               variant={ButtonVariant.PRIMARY}
               compact
               elementRef={buttonRef}
               type={'button'}
            />
         </EmergencyNotificationTooltip>
         <EmergencyNotificationKeyboardListener buttonRef={buttonRef} />
      </>
   );
};

EmergencyNotificationButton.displayName = 'EmergencyNotificationButton';
